import { OnInit, Component, ViewChild, EventEmitter, Output } from "@angular/core";
import { DataListModel } from "../../shared/config";
import { TranslateService } from "../../shared/translate/translate.service";
import { SharedVehicleGroupModel } from "../../sharedvehiclegroup/models/sharedvehiclegroup.model";
import { SharedVehicleGroupService } from "../../sharedvehiclegroup/models/sharedvehiclegroup.service";
import { AuthService } from "../../shared/models/auth.service";
import { SVGVehicleModel } from "../../vehicle/models/vehicle.model";
import { SVGModel } from "../model/batch-upload-person.model";

@Component({
  selector: 'wego-assign-svg-popup',
  template: require('../views/assign-to-svg-popup.component.html'),
  providers: [SharedVehicleGroupService],
})

export class AssignToSVGComponent implements OnInit {
  isParentCheck: boolean;
  instanceHashId: string;
  isLoading: boolean;
  DataListModel: DataListModel;
  sharedVehicleGroupList: SharedVehicleGroupModel[];
  apiErrorMsg: string;
  private breadCrumbTitle: string;
  public sharedVehicleGroupHashId: string;
  LblIcon: string;
  LblAssignToSvg: string;
  sVGModel: SVGModel[];
  organizationMasterHashId: string;


  constructor(private translate: TranslateService,
    private SVGService: SharedVehicleGroupService,
    private authService: AuthService
  ) { }

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('assignToSVGModal') public assignToSVGModal: any;

  ngOnInit() {
    this.LblAssignToSvg = this.translate.instant('LblAssign') + " " + this.translate.instant('LblSharedVehicleGroup');
    this.LblIcon = 'fa fa-plus-square';
    this.breadCrumbTitle = this.LblAssignToSvg;
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["groupName"];
  }

  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.GetSVGList();
    this.assignToSVGModal.show();
  }

  public hide(): void {
    this.assignToSVGModal.hide();
  }

  private GetSVGList() {
    this.isLoading = true;
    this.SVGService.GetSVGListForBatchUpload(this.instanceHashId, this.organizationMasterHashId, this.DataListModel)
      .subscribe(
      res => {
        this.sharedVehicleGroupList = res.data;
        this.sharedVehicleGroupList.forEach(x => {
          x.selectedSubscription = x.listOfSubscription[0].organizationSubscriptionHashId;
        });

        if (this.sVGModel != null && this.sVGModel.length > 0) {
          this.sharedVehicleGroupList.filter(x => this.sVGModel.map(svg => svg.sharedvehiclegroupHashId).indexOf(x.sharedvehiclegroupHashId) > -1)
            .forEach(x => {
              x.isChecked = true;
              let subscriptionHashId = this.sVGModel.find(y => y.sharedvehiclegroupHashId == x.sharedvehiclegroupHashId).subscriptionId;
              x.selectedSubscription = x.listOfSubscription.some(y => y.organizationSubscriptionHashId == subscriptionHashId) ? subscriptionHashId : x.listOfSubscription[0].organizationSubscriptionHashId;
            });
        }

        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetSVGList();
  }

  public OnParentCheck(isChecked: boolean) {
    this.sharedVehicleGroupList.forEach(x => x.isChecked = isChecked);
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetSVGList();
  };

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetSVGList();
  }

  private OnAdd(event: any) {
    let sVGModel1: SVGModel[];
    sVGModel1 = this.sharedVehicleGroupList.filter(x => x.isChecked).map(x => {
      let temp = new SVGModel();
      temp.sharedvehiclegroupHashId = x.sharedvehiclegroupHashId;
      temp.subscriptionId = x.selectedSubscription;
      temp.groupName = x.groupName;
      temp.subscriptionName = x.listOfSubscription.find(x => x.organizationSubscriptionHashId == temp.subscriptionId).name;
      return temp
    });
    this.OnSuccessSelect(sVGModel1);
    this.assignToSVGModal.hide();
  }

  private OnSuccessSelect(sVGModel: SVGModel[]) {
    this.onSuccessSelect.emit({ SVGModel: sVGModel })
  }

  get isAnyChecked(): boolean {
    if (this.sharedVehicleGroupList) {
      let isCheck = this.sharedVehicleGroupList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.sharedVehicleGroupList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }
      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/batchuploadperson/component/assign-to-svg-popup.component.ts